<template>
  <ItemRow :class="$style.row">
    <ItemWithLabel
      :class="$style.col1"
      :column="columns[0]"
    >
      <span v-if="isProvider">
        MSP - {{ displayName }}
      </span>
      <Link
        v-else
        :class="$style.link"
        :text="displayName"
        :to="editLink"
      />
    </ItemWithLabel>
    <ItemWithLabel
      :class="$style.col2"
      :column="columns[1]"
    >
      {{ itemData.email }}
    </ItemWithLabel>
    <ItemWithLabel
      :class="$style.col3"
      :column="columns[2]"
    >
      {{ itemData.roleName }}
    </ItemWithLabel>
    <ItemWithLabel
      :class="$style.col4"
      :column="columns[3]"
    >
      <StatusBadgeMFA
        :enableMultiFactor="itemData.enableMultiFactor"
        :totpEnrolled="itemData.totpEnrolled"
      />
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';
import StatusBadgeMFA from 'client/settings/AdministratorSettings/Badges/StatusBadgeMFA.vue';

export default {
  name: 'AdministratorRow',

  components: {
    Link,
    ItemWithLabel,
    ItemRow,
    StatusBadgeMFA,
  },

  toLocaleString,

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    itemData: {
      required: true,
      type: Object,
    },
  },

  computed: {
    displayName() {
      const { firstname, lastname } = this.itemData;
      let displayName;

      if (firstname || lastname) {
        displayName = `${firstname} ${lastname}`;
      }

      return displayName || '[No Name]';
    },

    editLink() {
      return `/settings/administrators/details/${this.itemData.id}`;
    },

    isProvider() {
      return this.itemData.provider != null;
    },
  },
};
</script>

<style module scoped>
.row {
  grid-template:
    'col1 col1' auto
    'col2 col2' auto
    'col3 col3' auto
    'col4 col4' auto /
    1fr 1fr;
}

.col1 {
  grid-area: col1;
}

.col2 {
  grid-area: col2;
}

.col3 {
  grid-area: col3;
}

.col4 {
  grid-area: col4;
}

.link.link {
  display: inline;
}

@media (min-width: 48rem) {
  .row {
    grid-template: 'col1 col2 col3 col4' auto / var(--list-column-template);
  }
}
</style>
